<template>
    <div>
        <el-popover
            ref="subscribe-popover"
            placement="bottom"
            width="148"
            trigger="click"
            popper-class="dark-popper"
            @hide="hideSubscribePopover"
        >
            <div>
                <div class="popover-title">DO YOU WANT TO STOP ?</div>
                <div class="actions">
                    <el-button type="text" class="decline" @click="hideSubscribePopover()">No</el-button>
                    <el-button type="text" class="accept" @click="cancelConfiguration()">Yes</el-button>
                </div>
            </div>
            <el-button
                slot="reference"
                type="text"
                class="stop-button"
                @click="onCancelling"
            ></el-button>
        </el-popover>
    </div>
</template>

<script>

export default {

    components: {
    },

    props: {
        parent: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
        };
    },

    computed: {
    },
    mounted (){
    },

    methods: {
        hideSubscribePopover() {
            this.parent.finallyNoCancel();
            if (this.$refs['subscribe-popover']) {
                this.$refs['subscribe-popover'].showPopper = false;
            }
        },
        cancelConfiguration() {
            this.parent.cancelConfiguration();
            this.hideSubscribePopover();
        },
        onCancelling (){
            this.parent.onCancelling();
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/stop-btn.vue